import React from "react";
import { FormattedMessage } from "react-intl";

export const shipmentCreationFailedMessage = (
  <FormattedMessage
    id="inbounds.toast.shipmentCreationFailedMessage"
    defaultMessage="There was an error creating your shipment(s). Please try again later or contact support."
  />
);
